<div mat-dialog-title>Classroom 360 Access</div>

<mat-dialog-content>
  <div>Classroom 360 is not yet available in the early release of version 3.</div>
  <div style="padding-top:20px;">
    Currently you will only be able to access the student information pages, which are view-only.
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="flex-footer-right">
    <tyl-button id="studentSearchWarningCancelButton" image="cancel.png" label="Close" (clickEvent)="closeClick()">
    </tyl-button>
  </div>
</mat-dialog-actions>